import { html2text } from './util/util.js';
import { charEntropy } from '@dsee/util/strings.js';


/**
 * Валидация энтропии
 */
export function entropy(threshold) {
    return (value) => {
        if (!value)
            return false;

        if (typeof (value) !== 'string')
            throw new TypeError('Parameter is not a string');

        return charEntropy(value) >= threshold;
    };
}


// Регулярка для меток AD. Разрешаем: буквы, цифры, пробел, дефис, точку, слэш и запятую.
const adLabelRegex = /\s*\([А-Яа-яЁёA-Za-z0-9./,\s-]+\)$/u;

/**
 * Валидация ФИО
 */
export function fio(value) {
    if (typeof value !== 'string')
        return true;

    if (!value)
        return true;

    // отсекаем суффикс из AD в конце строки ((B2O), (МФ)) перед валидацией
    const normalizedName = value.replace(adLabelRegex, '').trim();
    const words = normalizedName.split(/\s+/);

    if (words.length < 2 || words.length > 5)
        return false;

    return words.every((it) => /^[А-Яа-яЁё]{2,}(?:-[А-Яа-яЁё]{2,})*$/u.test(it));
}


export function emailOrPhone(val, item) {
    return item.phone || item.email;
}


/**
 * Валидация имени
 */
export function name(value) {
    if (!value)
        return true;

    return /^[\wА-Яа-яЁё\s\[\]()/\-.,!?_"']+$/.test(value);
}


/**
 * Проверка текста на пустоту, удаляя теги html
 */
export function hasHtmlText(value) {
    if (!value)
        return false;

    const result = html2text(value);
    return result.length > 0;
}


/**
 * Проверка на соответствие одной из длин
 */
export function requireLength(...lengths) {
    return (value) => {
        if (value == null)
            return false;

        return lengths.some((it) => value.length === it);
    };
}


/**
 * Валидация даты
 */
export function dateRange(value) {
    if (value == null)
        return true;

    if (!Array.isArray(value))
        return false;

    if (value.length !== 2)
        return false;

    return value.every((it) => it instanceof Date);
}
